import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormControl, Select } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';

import {
  NOT_EXCEED_50,
  NOT_EXCEED_100,
  EXCEED_100,
} from '@/modules/Simulators';

import useStyles from '../style';

export const options = [
  {
    value: NOT_EXCEED_50,
    label: 'NOT_EXCEED_50',
  },
  {
    value: NOT_EXCEED_100,
    label: 'NOT_EXCEED_100',
  },
  {
    value: EXCEED_100,
    label: 'EXCEED_100',
  },
];
export default function BoundField({ params, changeParams }) {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      classes={{ root: classes.grid }}
      container
      justifyContent="center"
      alignItems="center"
    >
      <FormControl classes={{ root: classes.formControl }}>
        <p className={classes.subSettingsHeader}>
          <FormattedMessage id="bound" defaultMessage="" />
        </p>
      </FormControl>
      <Select
        MenuProps={{
          style: { zIndex: 2000 },
        }}
        className="settings-input"
        disableUnderline
        inputProps={{ name: 'bound' }}
        value={params.bound}
        onChange={event => changeParams(event.target.value, event.target.name)}
        IconComponent={ExpandMoreIcon}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <FormattedMessage id={option.label} defaultMessage="" />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

BoundField.propTypes = {
  changeParams: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};
